export const LOGO_URL = "/logo.png";

export const CONTACTS = {
  phoneDisplay: "+351 962 856 440",
  phoneHref: "tel:+351962856440",
  phone2Display: "+351 935 461 766",
  phone2Href: "tel:+351935461766",
  whatsapp: "351962856440",
  whatsappMessage:
    "Olá EcoJard! Gostaria de pedir um orçamento gratuito para o meu espaço verde.",
  email: "ecojard2211@gmail.com",
  instagram: "https://www.instagram.com/ecoj.ard",
  facebook: "https://www.facebook.com/share/1W32xkks5Z/",
};

export const waLink = (msg) =>
  `https://wa.me/${CONTACTS.whatsapp}?text=${encodeURIComponent(
    msg || CONTACTS.whatsappMessage
  )}`;

const U = "&auto=format&fit=crop&w=1400&q=80";

export const IMAGES = {
  hero:
    "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwzfHxsYW5kc2NhcGluZyUyMGdhcmRlbnxlbnwwfHx8fDE3OTA4NDU1OTF8MA&ixlib=rb-4.1.0" + U,
  about:
    "https://images.unsplash.com/photo-1622383563227-04401ab4e5ea?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxnYXJkZW5lcnxlbnwwfHx8fDE3OTA4NDU1OTF8MA&ixlib=rb-4.1.0" + U,
};

export const SERVICES = [
  {
    slug: "manutencao-de-jardins",
    icon: "Sprout",
    title: "Manutenção de Jardins",
    short:
      "Relva aparada, plantas saudáveis, canteiros limpos e sebes alinhadas, para o seu jardim estar sempre no seu melhor.",
    image:
      "https://images.unsplash.com/photo-1779565145536-ccdf57517151?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzJ8MHwxfHNlYXJjaHw0fHxyZXNpZGVudGlhbCUyMGJhY2t5YXJkJTIwZ3JlZW4lMjBsYXduJTIwZ2FyZGVufGVufDB8fHx8MTc5MTEwOTI1M3ww&ixlib=rb-4.1.0" + U,
    metaTitle: "Manutenção de Jardins em Arruda dos Vinhos, Loures e Lisboa | EcoJard",
    metaDescription:
      "Manutenção profissional de jardins em Arruda dos Vinhos, Alenquer, Vila Franca de Xira, Loures e Lisboa. Planos regulares e serviços pontuais. Orçamento gratuito.",
    intro:
      "Um jardim bonito não se faz num dia: mantém-se. A EcoJard trata de tudo, da relva aparada às plantas saudáveis, canteiros limpos e sebes alinhadas, com visitas planeadas à medida do seu espaço e de cada estação do ano.",
    includes: [
      "Corte e aparamento de relva",
      "Poda e aparação de sebes e arbustos",
      "Limpeza de canteiros e remoção de infestantes",
      "Tratamento e adubação de plantas",
      "Limpeza de folhas e remoção de resíduos verdes",
      "Verificação de rega e pequenos arranjos",
    ],
    closing:
      "Trabalhamos com moradias, quintas e jardins particulares em Arruda dos Vinhos, Alenquer, Vila Franca de Xira, Loures e toda a região de Lisboa. Diga-nos o que precisa e apresentamos uma proposta clara, sem compromisso.",
  },
  {
    slug: "manutencao-de-condominios",
    icon: "Building2",
    title: "Condomínios",
    short:
      "Espaços comuns impecáveis, com planos de manutenção claros para administradores e empresas de gestão.",
    image:
      "https://images.unsplash.com/photo-1700689807667-82630348b301?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHw0fHxsYW5kc2NhcGluZyUyMGdhcmRlbnxlbnwwfHx8fDE3OTA4NDU1OTF8MA&ixlib=rb-4.1.0" + U,
    metaTitle: "Manutenção de Condomínios em Vila Franca de Xira, Loures e Lisboa | EcoJard",
    metaDescription:
      "Manutenção de espaços verdes de condomínios em Vila Franca de Xira, Loures, Arruda dos Vinhos e Lisboa. Propostas claras para administradores. Visita de avaliação gratuita.",
    intro:
      "Os espaços comuns são o cartão-de-visita de qualquer condomínio. A EcoJard trabalha diretamente com administradores e empresas de gestão, garantindo relvados, sebes e zonas verdes sempre apresentáveis, com comunicação simples e intervenções planeadas.",
    includes: [
      "Planos de manutenção com periodicidade definida",
      "Corte de relva nas zonas comuns",
      "Aparação de sebes e poda de arbustos",
      "Limpeza de canteiros, passeios e zonas verdes",
      "Remoção de resíduos verdes",
      "Resposta a intervenções pontuais entre visitas",
    ],
    closing:
      "Apresentamos propostas claras para assembleias e administradores, sem custos escondidos. Fale connosco e agende uma visita de avaliação gratuita ao condomínio.",
  },
  {
    slug: "empresas-e-espacos-comerciais",
    icon: "Briefcase",
    title: "Empresas e Espaços Comerciais",
    short:
      "A imagem da sua empresa começa à porta. Espaços verdes cuidados, sem perturbar a atividade do negócio.",
    image:
      "https://images.unsplash.com/photo-1668120089662-42642838cfef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA6MjJ8MHwxfHNlYXJjaHwzfHxsYW5kc2NhcGluZyUyMGdhcmRlbnxlbnwwfHx8fDE3OTA4NDU1OTF8MA&ixlib=rb-4.1.0" + U,
    metaTitle: "Manutenção de Espaços Verdes para Empresas na Região de Lisboa | EcoJard",
    metaDescription:
      "Manutenção de espaços verdes para empresas, escritórios e espaços comerciais na região de Lisboa. Contratos anuais, intervenções discretas e orçamento gratuito.",
    intro:
      "A imagem da sua empresa começa à porta. Mantemos os espaços verdes de escritórios, unidades industriais, lojas e espaços comerciais com discrição e profissionalismo, sem perturbar a atividade do seu negócio.",
    includes: [
      "Manutenção programada fora das horas de maior movimento",
      "Corte de relva e aparação de sebes",
      "Limpeza de zonas verdes e áreas envolventes",
      "Plantação e substituição de plantas",
      "Contratos de manutenção anuais",
      "Registo das intervenções realizadas",
    ],
    closing:
      "Escritórios, unidades industriais, lojas ou espaços comerciais: apresentamos uma proposta à medida das dimensões e exigências do seu espaço, na região de Lisboa e arredores.",
  },
  {
    slug: "corte-de-relva-e-sebes",
    icon: "Scissors",
    title: "Corte de Relva e Sebes",
    short:
      "Relva bem cortada e sebes alinhadas, com equipamento profissional e acabamento limpo e uniforme.",
    image:
      "https://images.unsplash.com/photo-1690068023694-053da714f95f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxsYXduJTIwbW93ZXJ8ZW58MHx8fHwxNzkwODQ1NTkxfDA&ixlib=rb-4.1.0" + U,
    metaTitle: "Corte de Relva e Aparação de Sebes em Arruda dos Vinhos e Lisboa | EcoJard",
    metaDescription:
      "Corte de relva e aparação de sebes em Arruda dos Vinhos, Alenquer, Vila Franca de Xira, Loures e Lisboa. Acabamento profissional, serviços pontuais ou regulares.",
    intro:
      "Relva bem cortada e sebes alinhadas transformam qualquer espaço. Utilizamos equipamento profissional para um acabamento limpo e uniforme, seja num pequeno jardim ou num relvado de grandes dimensões.",
    includes: [
      "Corte de relva com acabamento aparado",
      "Aparação de sebes de todas as dimensões",
      "Poda ligeira de arbustos ornamentais",
      "Aparas recolhidas e removidas no final",
      "Serviços pontuais ou com periodicidade",
      "Orçamento gratuito e sem compromisso",
    ],
    closing:
      "Envie-nos fotografias do espaço ou agende uma visita: indicamos rapidamente o valor do serviço, sem surpresas.",
  },
  {
    slug: "limpeza-de-terrenos-e-corte-de-mato",
    icon: "Trees",
    title: "Limpeza de Terrenos e Corte de Mato",
    short:
      "Terrenos limpos, seguros e valorizados: corte de mato, remoção de silvas e gestão de combustível.",
    image:
      "https://images.unsplash.com/photo-1621272156568-7306716648df?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHxnYXJkZW5lcnxlbnwwfHx8fDE3OTA4NDU1OTF8MA&ixlib=rb-4.1.0" + U,
    metaTitle: "Limpeza de Terrenos e Corte de Mato em Alenquer, Arruda dos Vinhos e Lisboa | EcoJard",
    metaDescription:
      "Limpeza de terrenos e corte de mato em Alenquer, Arruda dos Vinhos, Vila Franca de Xira e Lisboa. Remoção de silvas, faixas de gestão de combustível e transporte de resíduos.",
    intro:
      "Terrenos limpos são mais seguros, mais valorizados e cumprem as obrigações legais de gestão de combustível. Fazemos corte de mato, remoção de silvas e limpeza geral de terrenos rústicos e urbanos.",
    includes: [
      "Corte de mato e vegetação espontânea",
      "Remoção de silvas e arbustos invasores",
      "Limpeza de terrenos para construção ou venda",
      "Faixas de gestão de combustível",
      "Transporte e destino correto dos resíduos",
      "Serviço pontual ou limpezas programadas",
    ],
    closing:
      "Atuamos em terrenos de qualquer dimensão em Alenquer, Arruda dos Vinhos, Vila Franca de Xira, Loures e região de Lisboa. Peça uma avaliação gratuita.",
  },
];

export const AREAS = [
  {
    name: "Arruda dos Vinhos",
    text: "A nossa área de eleição. Jardins, quintas e condomínios com acompanhamento próximo e visitas regulares.",
  },
  {
    name: "Alenquer",
    text: "Manutenção de jardins, limpeza de terrenos e corte de mato em toda a zona de Alenquer.",
  },
  {
    name: "Vila Franca de Xira",
    text: "Condomínios, empresas e moradias com planos de manutenção à medida de cada espaço.",
  },
  {
    name: "Loures",
    text: "Espaços verdes urbanos e condomínios com resposta rápida e equipamento profissional.",
  },
  {
    name: "Região de Lisboa",
    text: "Deslocamo-nos a várias localidades da região de Lisboa. Contacte-nos para confirmar disponibilidade na sua zona.",
  },
];

export const MARQUEE = [
  "Manutenção de Condomínios",
  "Corte de Relva e Sebes",
  "Limpeza de Terrenos",
  "Espaços Verdes Empresariais",
  "Orçamentos Gratuitos",
  "Jardinagem Profissional",
];

export const TESTIMONIALS = [
  {
    text: "Já contratei 2 vezes esta empresa para tratar da limpeza do meu terreno e posso dizer que ficou tudo impecável! Recomendo.",
    author: "João Diogo",
    meta: "Avaliação na Zaask · Julho 2026",
  },
  {
    text: "Prestável, sério e humilde, o terreno ficou top, recomendo.",
    author: "Elisabete Monteiro",
    meta: "Avaliação na Zaask · Julho 2026",
  },
  {
    text: "Um bom profissional, pontual, trabalho impecável, 5 estrelas. Recomendo.",
    author: "Gomes Ida",
    meta: "Avaliação na Zaask · Julho 2026",
  },
  {
    text: "Excelente.",
    author: "Ana Espinheira",
    meta: "Avaliação na Zaask · Julho 2026",
  },
];

export const BEFORE_AFTER = [
  {
    id: "terreno-mato",
    title: "Limpeza de Terreno e Corte de Mato",
    before: "/trabalhos/t1.jpg",
    after: "/trabalhos/t2.jpg",
  },
  {
    id: "quintal",
    title: "Limpeza de Quintal e Remoção de Infestantes",
    before: "/trabalhos/t3.jpg",
    after: "/trabalhos/t4.jpg",
  },
  {
    id: "terreno-rustico",
    title: "Corte de Mato em Terreno Rústico",
    before: "/trabalhos/t5.jpg",
    after: "/trabalhos/t6.jpg",
  },
  {
    id: "patio-acesso",
    title: "Limpeza de Pátio e Zona de Acesso",
    before: "/trabalhos/t7.jpg",
    after: "/trabalhos/t8.jpg",
  },
  {
    id: "terreno-encosta",
    title: "Limpeza de Terreno em Encosta",
    before: "/trabalhos/t9.jpg",
    after: "/trabalhos/t10.jpg",
  },
  {
    id: "terreno-pinheiro",
    title: "Corte de Mato em Terreno Declivoso",
    before: "/trabalhos/t11.jpg",
    after: "/trabalhos/t12.jpg",
  },
  {
    id: "lote-residencial",
    title: "Limpeza de Lote em Zona Residencial",
    before: "/trabalhos/t13.jpg",
    after: "/trabalhos/t14.jpg",
  },
];
